import { Auth0ContextInterface, useAuth0 } from '@auth0/auth0-react';
import { AuthError, Modal } from 'Common/common-ui';
import { LoadingIndicator } from '@toolkit/common';
import React, { ReactNode, Suspense, useMemo } from 'react';
import VerifyEmailRequired from './layout/other/VerifyEmailRequired';
import AppRouter from '@toolkit/router/AppRouter';

const Auth0Messages = {
  VERIFY_EMAIL: 'Please verify your email before logging in',
  INVALID_STATE: 'Invalid state',
};

export default function App(): ReactNode {
  const auth0: Auth0ContextInterface = useAuth0();
  const router = useMemo(() => <AppRouter />, []);
  let showModal = false;

  if (auth0.error) {
    if (auth0.error.message === Auth0Messages.INVALID_STATE) {
      auth0.loginWithRedirect();
      return (
        <LoadingIndicator fullScreen={true} title="Loading application..." />
      );
    } else if (auth0.error.message === Auth0Messages.VERIFY_EMAIL) {
      showModal = true;
    } else {
      return (
        <Suspense
          fallback={
            <LoadingIndicator fullScreen={true} title="Processing error..." />
          }
        >
          <AuthError
            reason={auth0.error.name}
            message={auth0.error.message}
            logout={auth0.logout as () => void}
          />
        </Suspense>
      );
    }
  }

  function handleCloseModal(e: React.MouseEvent) {
    e.preventDefault();
    auth0.logout({ logoutParams: { returnTo: window.location.origin } });
  }

  return (
    <>
      <Suspense
        fallback={
          <LoadingIndicator fullScreen={true} title="Loading application..." />
        }
      >
        <Modal
          open={showModal}
          onClose={handleCloseModal}
          title="Email verification is required before logging in"
        >
          <VerifyEmailRequired />
        </Modal>
        {!auth0.isLoading && router}
      </Suspense>
    </>
  );
}
